import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SuccessfulPurchaseComponent } from './successful-purchase/successful-purchase.component';
import { CheckoutComponent } from './checkout.component';
import { PurchaseAndSummaryComponent } from './purchase-and-summary/purchase-and-summary.component';
import { CanActivatePurchaseAndSummaryGuard } from './purchase-and-summary/can-activate-purchase-and-summary/can-activate-purchase-and-summary.guard';
import { CanActivateSuccessfulPurchaseGuard } from './successful-purchase/can-activate-successful-purchase/can-activate-successful-purchase.guard';

const routes: Routes = [
    {
        path: '',
        component: CheckoutComponent,
        children: [
            {
                component: PurchaseAndSummaryComponent,
                canActivate: [CanActivatePurchaseAndSummaryGuard],
                path: '',
                pathMatch: 'full',
            },
            {
                component: SuccessfulPurchaseComponent,
                canActivate: [CanActivateSuccessfulPurchaseGuard],
                path: 'successful-purchase',
                pathMatch: 'full',
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CheckoutRoutingModule {}
